export const convertAddressItemToFiasAddressItem = (item) => {
    if (!item) {
        return;
    }
    return {
        text: '',
        name: item?.name || '',
        data: {
            name: item?.name || '',
            id: '',
            code: item?.kladrCode || undefined,
            fiasId: item?.fiasId || '',
            abbreviation: item?.abbreviation || '',
        },
    };
};
